import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import Lightbox from 'react-image-lightbox';
import Slider from 'react-slick';
import useTranslations from '@hooks/useTranslation';
import { getApiURL } from '../../constants';
import { calendarApi } from '../../services/calendar.service';
import { breakpoints } from '../../styles/theme';
import { CarouselWrapper, Gallery, GalleryImage, ImageWrapper } from './ConferencePhotoGallery.elements';

interface ConferenceProps {
    gallery?: string;
}

const ConferencePhotoGalleryContentImageTemplate: FC<ConferenceProps> = ({ gallery }) => {
    const { t } = useTranslations();

    const [images, setImages] = useState([]);
    const [countSlides, setCountSlides] = useState(1);
    const [imgFocus, setImgFocus] = useState(false);
    const [imgIndex, setImgIndex] = useState(null);

    const loadImagesByGalleryKey = async (key: string) => {
        const response = await calendarApi.getGalleryImages(key);
        setImages(response.data.results);
        if (response.data.results.length === 1) {
            setCountSlides(1);
        } else if (response.data.results.length === 2) {
            setCountSlides(2);
        } else if (response.data.results.length > 2) {
            setCountSlides(3);
        }
    };

    useEffect(() => {
        if (gallery) {
            loadImagesByGalleryKey(gallery);
        }
    }, [gallery]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: countSlides,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: breakpoints.sm,
                settings: { slidesToShow: 1, dots: true },
            },
            {
                breakpoint: breakpoints.md,
                settings: { slidesToShow: 3, dots: true },
            },
        ],
    };

    return (
        <>
            {images.length > 0 && (
                <Gallery>
                    <CarouselWrapper>
                        <Slider {...settings}>
                            {images.map((img, index) => (
                                <ImageWrapper key={`image${gallery}${index}`}>
                                    <GalleryImage
                                        src={`${getApiURL()}/media/image/${img._key}/file`}
                                        onClick={() => {
                                            setImgIndex(index);
                                            setImgFocus(true);
                                        }}
                                    />
                                </ImageWrapper>
                            ))}
                        </Slider>
                    </CarouselWrapper>
                </Gallery>
            )}

            {imgFocus && (
                <Lightbox
                    mainSrc={`${getApiURL()}/media/image/${images[imgIndex]._key}/file`}
                    nextSrc={images[(imgIndex + 1) % images.length]}
                    prevSrc={images[(imgIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => setImgFocus(false)}
                    onMovePrevRequest={() => setImgIndex((imgIndex + images.length - 1) % images.length)}
                    onMoveNextRequest={() => setImgIndex((imgIndex + 1) % images.length)}
                />
            )}
        </>
    );
};

export default ConferencePhotoGalleryContentImageTemplate;
